module.exports = __webpack_public_path__ + "static/media/banner-bg.29cc9b55.webp";